import { Button, Tabs } from 'antd';
import type { TabsProps } from 'antd';
import FaturaForm, { IFaturaFormProps } from './FaturaForm';
import TituloConsultaScreen from '../TituloConsultaScreen';
import { useMemo, useState } from "react";
import Titulo, { EnumTituloTipo } from '@/Models/Financeiro/Titulo/Titulo';
import { EnumPessoaTipo } from '@/Models/Pessoa/Pessoa';
import { useFaturaBuscar } from '@/Services/Financeiro/Titulo/FaturaService';
import { Link, useParams } from 'react-router-dom';
import { describe } from 'node:test';

export interface IFaturaFormScreenProps {
    codigo?:number;
    formProps?:IFaturaFormProps;
}

export default function FaturaFormScreen ({
    codigo : codigoParam,
    formProps
}:IFaturaFormScreenProps) {
    const { codigo_fatura : codigoRota } = useParams();
    const codigoInit = isNaN(Number.parseInt(codigoRota ?? "")) ? codigoParam : Number.parseInt(codigoRota ?? "");

    const [codigo, setCodigo] = useState<null|number>(codigoInit ?? null);
    const [tabAtual, setTabAtual] = useState<'1'|'2'>('1');

    const {
        isSuccess,
        refetch,
        data
    } = useFaturaBuscar({
        codigo: codigo ?? -1,
        ativo: null,
        enabled: (codigo ?? 0) > 0
    });

    const receita = useMemo(() => (codigo ?? 0) <= 0 ? formProps?.isAReceber : (data?.data?.beneficiario?.tipo === EnumPessoaTipo.EMPRESA ? true : false), [codigo, formProps?.isAReceber, data?.data?.beneficiario?.tipo]);

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Título',
            children: <FaturaForm 
                {...formProps}
                codigo={codigo ?? undefined}
                isAReceber={receita}
                onSucess={(codigo) => {
                    setCodigo(codigo);
                    refetch();
                    setTabAtual('2');
                    formProps?.onSucess?.(codigo);
                }}
            />,
        },
        {
            key: '2',
            label: 'Parcelas',
            children: <TituloConsultaScreen 
                defaultFilters={{
                    titulo : {
                        codFatura : codigo
                    } as Titulo
                }}
                exibirCamposFiltro={false}
                receita={receita}
                formCadastroProps={{
                    aReceberProps: {
                        defaultValues: {
                            codFatura : codigo,
                            codTipo : EnumTituloTipo.Parcela,
                            codOrigem : isSuccess ? data?.data?.codOrigem : undefined,
                            origem : isSuccess ? data?.data?.origem : undefined,
                            beneficiario : isSuccess ? data?.data?.beneficiario : undefined,
                            codBeneficiario : isSuccess ? data?.data?.codBeneficiario : undefined,
                            codDevedor : isSuccess ? data?.data?.codDevedor : undefined,
                            devedor : isSuccess ? data?.data?.devedor : undefined,
                            reembolsavel : isSuccess ? data?.data?.devedor : undefined,
                            restrito : isSuccess ? data?.data?.restrito : undefined,
                            comprovante : isSuccess ? data?.data?.comprovante : undefined,
                            urlComprovante : isSuccess ? data?.data?.urlComprovante : undefined,
                            descricao : isSuccess ? data?.data?.descricao : undefined,
                            fatura : isSuccess ? {
                                rateios : isSuccess ? data?.data?.rateios : undefined,
                            } : undefined
                        } as any,// Titulo<any>,
                        disable: {
                            titulo: {
                                codOrigem : true,
                                codFatura : true,
                                reembolsavel : true,
                                comprovante : true,
                                urlComprovante : true,
                                descricao : true
                            }
                        },
                    },
                    aPagarProps: {
                        defaultValues: {
                            codFatura : codigo,
                            codTipo : EnumTituloTipo.Parcela,
                            codOrigem : isSuccess ? data?.data?.codOrigem : undefined,
                            origem : isSuccess ? data?.data?.origem : undefined,
                            beneficiario : isSuccess ? data?.data?.beneficiario! : undefined,
                            codBeneficiario : isSuccess ? data?.data?.codBeneficiario! : undefined,
                            codDevedor : isSuccess ? data?.data?.codDevedor! : undefined,
                            devedor : isSuccess ? data?.data?.devedor! : undefined,
                            reembolsavel : isSuccess ? data?.data?.devedor! : undefined,
                            restrito : isSuccess ? data?.data?.restrito : undefined,
                            comprovante : isSuccess ? data?.data?.comprovante! : undefined,
                            descricao : isSuccess ? data?.data?.descricao : undefined,
                            urlComprovante : isSuccess ? data?.data?.urlComprovante! : undefined,
                            fatura : isSuccess ? {
                                rateios : isSuccess ? data?.data?.rateios : undefined,
                            } : undefined
                        } as any,// as Titulo<any>,
                        disable: {
                            titulo: {
                                codOrigem : true,
                                codFatura : true,
                                reembolsavel : true,
                                comprovante : true,
                                urlComprovante : true,
                                descricao : true
                            }
                        },
                    },
                }}
            />,
            disabled : (codigo ?? 0) <= 0
        }
    ];
    
    return <>
        {data?.data?.codFaturaReembolsada && <Link target='_blank' to={`/financeiro/titulos/fatura/editar-ficha/${data?.data?.codFaturaReembolsada}`}>Ir para reembolsada (Título Nº {data?.data?.codFaturaReembolsada})</Link>}
        {data?.data?.codFaturaReembolso && <Link target='_blank' to={`/financeiro/titulos/fatura/editar-ficha/${data?.data?.codFaturaReembolso}`}>Ir para reembolso (Título Nº {data?.data?.codFaturaReembolso})</Link>}
        <Tabs
            defaultActiveKey="1"
            onChange={(e) => setTabAtual(e as '1'|'2')}
            activeKey={tabAtual}
            items={items}
            destroyInactiveTabPane={true}
        />
    </>
}